import { atom } from 'jotai';

import type { DownloadQueueState, DownloadItem } from '../types';

/**
 * Main download queue state (in-memory, no persistence)
 */
export const downloadQueueAtom = atom<DownloadQueueState>({
  downloads: {},
  activePollingIds: new Set<string>(),
});

/**
 * Derived atom: active downloads currently processing
 * Returns downloads that are pending or polling and have a server task ID
 */
export const activeDownloadsAtom = atom(get => {
  const queue = get(downloadQueueAtom);
  return Object.values(queue.downloads).filter(
    (d): d is DownloadItem => ['pending', 'polling'].includes(d.status) && Boolean(d.serverTaskId),
  );
});
